export const PROMPT_CATEGORIES = [
    'All Categories',
    'Content / SEO',
    'Email Marketing',
    'Paid Ads',
    'PR / Communication',
    'Social',
    'Customer Service',
    'Text Processing',
    'Sales',
    'Business',
    'Education',
    'Product',
    'Strategy',
    'Custom',
];
